import { loadStripe } from '@stripe/stripe-js'

const stripePublishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY

// Check if environment variable is properly set
if (!stripePublishableKey) {
  console.warn('Stripe environment variable is not set. Please add REACT_APP_STRIPE_PUBLISHABLE_KEY to your .env.local file')
}

const stripePromise = stripePublishableKey 
  ? loadStripe(stripePublishableKey)
  : Promise.resolve(null)

export { stripePromise }

export interface PaymentIntent {
  id: string
  amount: number
  currency: string
  status: string
  client_secret: string
}

export interface StripeProduct {
  id: string
  name: string
  description: string
  price: number
  currency: string
  interval?: 'month' | 'year'
  package_type: 'in_person' | 'online' | 'meal_plan'
}

// Utility function to format price
export const formatPrice = (amount: number, currency: string = 'usd'): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency.toUpperCase(),
  }).format(amount / 100)
}

// Create payment intent
export const createPaymentIntent = async (amount: number, currency: string = 'usd') => {
  try {
    const response = await fetch('/api/create-payment-intent', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        amount,
        currency,
      }),
    })
    
    if (!response.ok) {
      throw new Error('Failed to create payment intent')
    }
    
    return await response.json()
  } catch (error) {
    console.error('Error creating payment intent:', error)
    throw error
  }
} 